import { useState } from 'react';
import { useMutation } from 'react-query';
import { useHistory, useLocation } from 'react-router';
import { toast } from 'react-toastify';
import { useAppContext } from '../../appProvider/contextProvider';
import { Email_VALIDATOR, ERRORS, NAME_VALIDATOR } from '../../constants/AppConstants';
import { addAgent, updateAgent } from '../../services/userManagementService';


const AddAgent = () => {

    const history = useHistory();
    const {state} = useLocation();

    const {selectedWebsite } = useAppContext();

    const [name, setName] = useState(state?.agentsData?.name || '');
    const [nameError, setNameError] = useState(null);

    const [email, setEmail] = useState(state?.agentsData?.email ||'');
    const [emailError, setEmailError] = useState('');
    const [role, setRole] = useState(state?.agentsData?.role ||'view');

    const handelNameChange = (value) => {
        if(value.trim().length <= 0 ) {
            setNameError(ERRORS.NAME_REQUIRED);
        } else if(value.length > 30 ){
            setNameError(ERRORS.NAME_MAX_LENGTH);
        }
        else if(!value.match(NAME_VALIDATOR)) {
            setNameError(ERRORS.IN_VALID_NAME);
        } else {
            setNameError(null);
        }
        setName(value)
    }

    const handelEmailChange = (value) => {
        if(value.trim().length <= 0 ) {
            setEmailError(ERRORS.EMAIL_REQUIRED);
        }
        else if(!value.match(Email_VALIDATOR)) {
            setEmailError(ERRORS.IN_VALID_EMAIL);
        } else {
            setEmailError(null);
        }
        setEmail(value)
    }

    const isSaveDisabled = () => {
        return name.length <= 0 || email.length <= 0 || emailError || nameError;
    }

    const register = useMutation((event) => {
        event.preventDefault();
        return addAgent(selectedWebsite?.id, {name, email, role});
    }, {
        onSuccess: ((agentData) => {
            if(agentData.errors) {
                // handelError(agentData.errors);
                toast.error(ERRORS[agentData.errors.email])
            } else {
                toast.success('We have sent you an email to Agent.');
                history.push('/user-management')   ;
                reset();
            }
        }),
        onError: ((error) => {
            toast.error(error.message);
        })
    });


    const update = useMutation((event) => {
        event.preventDefault();
        return updateAgent(selectedWebsite?.id, state.agentsData.id, {name, email, role});
    }, {
        onSuccess: ((agentData) => {
            if(agentData.errors) { 
                // handelError(agentData.errors);
            } else {
                reset();
                toast.success('Agent updated Successfully.');
                history.push('/user-management');
            }
        }),
        onError: ((error) => {
            toast.error(error.message);
        })
    });

    const reset = () => {
        setName('');
        setEmail('');

        setNameError(null);
        setEmailError(null);
    }


    return <>
    <div className="panel full-height">
        <div className="panel-header">
            <div className="d-flex flex-wrap justify-content-between align-items-center">
                <h3 className="mb-0"><i className="icon icon-chevron-left mr-2" onClick={() => history.push('/user-management')} ></i>Add User</h3>                                
            </div>                                
        </div>
        <div className="panel-body d-flex flex-column full-height scrollable_y">
            {/* <div className="custom-file-rounded">
                <input type="file" className="custom-file-input"/>
            </div> */}
            <div className="form-row">
                <div className="form-group col-12 col-sm-6 col-lg-4">
                    <label className="form-label text-dark medium">Name</label>
                    <input 
                        type="text"
                        placeholder="Enter Agent's Name" 
                        className="form-control"
                        value={name}
                        onChange={({target}) => handelNameChange(target.value)}
                    />
                    {nameError && <span className="error-message">{nameError}</span>}                          
                </div>
                <div className="form-group col-12 col-sm-6 col-lg-4">
                    <label className="form-label text-dark medium">Email</label>
                    <input 
                        type="text" 
                        placeholder="Enter Agent's Email "
                        className="form-control"
                        value={email}
                        onChange={({target}) => handelEmailChange   (target.value)}   
                    />
                    {emailError && <span className="error-message">{emailError}</span>}                                 
                </div>
            </div>
            <div className="form-group">
                <label className="form-label medium text-dark">Role</label>
                <div className="d-flex">
                    <div className="custom-control custom-radio mr-3">
                        <input 
                            checked = {role === 'view'}
                            onChange={({target}) => setRole(target.value)}
                            value="view"
                            type="radio" 
                            id="customRadio6" 
                            name="customRadio" 
                            className="custom-control-input"
                        />
                        <label className="custom-control-label" for="customRadio6">View</label>
                    </div>
                    <div className="custom-control custom-radio mr-3">
                        <input 
                            checked = {role === 'edit'}
                            onChange={({target}) => setRole(target.value)}
                            value="edit"
                            type="radio" 
                            id="customRadio4" 
                            name="customRadio" 
                            className="custom-control-input" />
                        <label className="custom-control-label" for="customRadio4">Edit</label>
                    </div>                                    
                    <div className="custom-control custom-radio">
                        <input 
                            checked = {role === 'send'}
                            onChange={({target}) => setRole(target.value)}
                            value="send"
                            type="radio" 
                            id="customRadio10" 
                            name="customRadio" 
                            className="custom-control-input" 
                        />
                        <label className="custom-control-label" for="customRadio10">Send</label>
                    </div>
                </div>
            </div>
            <div className="d-flex mt-2">                            
                {
                    !(!!state?.agentsData) ? 
                        <button className="btn btn-sm btn-primary" disabled={isSaveDisabled()} onClick={register.mutate} >Save</button>
                    :   <button className="btn btn-sm btn-primary" disabled={isSaveDisabled()} onClick={update.mutate} >Update</button>                            
                }

            </div>
        </div>
    </div>
</>
}

export default AddAgent;